import Vue from 'vue'
import Vuex from 'vuex'
import AuthStore from './modules/auth.store'
import SessionStore from './modules/session.store'
import productStore from './modules/product.store'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		auth: AuthStore,
		session: SessionStore,
		product: productStore,
	},
	state: {
	},
	getters: {
	},
	mutations: {
	},
	actions: {
	}
})

